export default "__VITE_ASSET__D14IzA46__"